const translations = {
    addFlight: 'Select Existing',
    back: 'Back',
    createAsAppliedMap: 'Create Application Map',
    export: 'Export',
    uploadFlights: 'Upload Flights'
};

export default translations;
